import api from '../plugins/axios';
import { allowedPrice } from '@/utils/utils';

function handleError(error) {
  console.error('API Error:', error);
}

export default {
  state: {
    rewards: {},
    purchases: [],
  },
  actions: {
    async loadRewards({ commit }) {
      try {
        const { data } = await api.get('/shop/rewards');
        commit('setRewards', data);
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async loadPurchases({ commit }) {
      try {
        const { data } = await api.get('/shop/purchases');
        commit('setPurchases', data);
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async exportPurchases(_, days = null) {
      const filter = days ? `?days=${days}` : '';
      const { data } = await api.get(`/rewards/purchases.csv${filter}`, { responseType: 'blob' });
      return data;
    },
    async purchaseReward({ dispatch }, { rewardId, comment, amount }) {
      const requestBody = {};
      if (comment) {
        requestBody.comment = comment;
      } else {
        requestBody.comment = '';
      }
      if (amount) requestBody.amount = amount;
      try {
        await api.post(`/shop/rewards/${rewardId}`, requestBody);
        await dispatch('loadRewards');
        await dispatch('loadPurchases');
        await dispatch('auth/getCurrentUser', null, { root: true });
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async cancelRequest({ dispatch }, { rewardId }) {
      try {
        await api.delete(`/shop/purchases/${rewardId}`);
        await dispatch('loadRewards');
        await dispatch('loadPurchases');
        await dispatch('auth/getCurrentUser', null, { root: true });
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async loadAutoRewardInfo(_, { rewardId }) {
      try {
        const { data } = await api.get(`/shop/rewards/${rewardId}`);
        return data;
      } catch (e) {
        handleError(e);
      }
    },
  },
  mutations: {
    setRewards(state, data) {
      state.rewards = data;
    },
    setPurchases(state, data) {
      state.purchases = data;
    },
  },
  getters: {
    sortedRewards(state) {
      if (state.rewards.length) {
        // Filter rewards first
        const filteredRewards = state.rewards.filter((reward) => allowedPrice(reward) > 0);

        // Group filtered rewards by category
        let groupedRewards = filteredRewards.reduce((acc, reward) => {
          const category = reward.category || 'uncategorised';
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push(reward);
          return acc;
        }, {});

        // Sort rewards within each category by `created_at`
        Object.keys(groupedRewards).forEach((category) => {
          groupedRewards[category].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        });

        return groupedRewards;
      }

      return {};
    },
  },
  namespaced: true,
};
